import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-extraction-ongoing-popup',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './extraction-ongoing-popup.component.html',
  styleUrl: './extraction-ongoing-popup.component.css'
})
export class ExtractionOngoingPopupComponent {
  @Input() visible = false;
  @Input() header = 'shared.extraction_ongoing';
}
